jQuery(document).ready(function () {
	if (jQuery('.logos').length) {
		var sliderSettings = {
			container: '.logos',
			loop: true,
			autoplay: true,
			autoplayButtonOutput: false,
			controls: true,
			gutter: 20,
			mouseDrag: true,
			responsive: {
				340: {
					items: 2,
				},
				640: {
					items: 4,
				},
				1000: {
					items: 6,
				},
			},
		};
		// Tiny Carousel smooth scroll
		if (typeof logoCarouselSmoothScroll !== 'undefined') {
			jQuery('.text-content .logos-container').addClass(
				'tiny-carousel-smooth-scroll'
			);
			jQuery.extend(sliderSettings, {
				speed: 2000,
				autoplayTimeout: 0,
				preventActionWhenRunning: true,
				controls: false,
				mouseDrag: false,
			});
		}
		var slider = tns(sliderSettings);
	}
});
